import { render, staticRenderFns } from "./success.vue?vue&type=template&id=70144e56&scoped=true&"
import script from "./success.vue?vue&type=script&lang=js&"
export * from "./success.vue?vue&type=script&lang=js&"
import style0 from "./success.vue?vue&type=style&index=0&id=70144e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70144e56",
  null
  
)

export default component.exports